'use client'

import NextTopLoader from 'nextjs-toploader'

import theme from '@/src/config/theme'

import {PageToastify} from '@/src/shared/ui/layout/ui'
import {Analythic} from '@/src/config/analythic'
import {getInjection} from '@runlab/di'
import {PageEventTypes, PageRedirectEvent} from '@/src/core/domain/events/page.events'
import {useEffect} from 'react'

const isProduction = true /*process.env.NODE_ENV === 'production'*/

const PageServices = () => {
  return (
    <>
      <RouteTopLoader />
      <PageToastify />
      <PageRedirectHandler />
      {isProduction && <Analythic />}
    </>
  )
}

const PageRedirectHandler = () => {
  useEffect(() => {
    const eventBus = getInjection('IEventBus')

    const subscription = eventBus.subscribe(PageEventTypes.Redirect, (event: PageRedirectEvent) => {
      if (event.payload) {
        // Terminal API redirects freeze callers. A document replacement also tears
        // down persistent layout queries/modals, including logout's redirect to '/'.
        window.location.replace(event.payload.url)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  return null
}
const RouteTopLoader = () => {
  return (
    <NextTopLoader
      color={theme.colors.primary}
      initialPosition={0.08}
      height={3}
      easing="ease"
      speed={500}
      shadow={`0 0 10px #2299DD,0 0 5px ${theme.colors.primary}`}
    />
  )
}

export default PageServices
